import React, { useEffect, useState, useMemo } from "react";
import advertisementImage from "../../assets/img/advertisement.svg";
import advertisementSpeaker from "../../assets/img/advertisement-speaker.svg";
import Translations from "../../services/translation.service";
import StorefrontTitle from "../shared/storefront-title.component";
import ReCAPTCHA from "react-google-recaptcha";
import Settings from "../../services/settings.service";
import AdvertisementPopup from "./success-modal";
import Storage from "../../services/storage.service";
import SpinnerTimeLoader from "../shared/timeLoading";
import Advertisement from "../../services/advertisement.service";

export default function AdvertismentOptList({
  number = "",
  history = ""
}) {
  const subscriptions = [];
  const prefix = "advertisement_";
  const [translationKeys, setTranslationsKeys] = useState(
    Translations.keys ? Translations.keys : {}
  );
  const [loading, setLoading] = useState(false);
  const [captchaChecked, setCaptchaChecked] = useState(false);
  const [showSucessModal, setShowSucessModal] = useState(false);

  const [optList, setOptList] = useState([]);

  useEffect(() => {
    setLoading(true);
    const payloadNumber = number[0] === "0" ? number.slice(1) : number
    Advertisement.getPreference(`966${payloadNumber}`)
      .then(response => {
        if (response && response?.data) {
          setLoading(false);
          const updatedOptList = Object.keys(response?.data).map((key)=>({
            key,
            checked:response?.data[key],
            isUpdated: false,
          }))
          setOptList(updatedOptList)
        }
      })
      .catch(() => {
        setLoading(false);
    });
    window.addEventListener("beforeunload", (event) => {
      // To show browser’s leave page alert.
      event.returnValue = true;
    });
    subscriptions.push(
      Translations.getKeysObsrv().subscribe((data) => {
        setTranslationsKeys(data);
      })
    );

    return () => {
      if (subscriptions && subscriptions?.length) {
        for (let subscription of subscriptions) {
          subscription.unsubscribe();
        }
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const updateCaptcha = (value) => {
    if (value) {
      setCaptchaChecked(true);
    } else {
      setCaptchaChecked(false);
    }
  };

  const updateCheckbox = (key) => {
    const updatedList = optList.map((option) => {
      if (option.key === key) {
        return {
          ...option,
          checked: !option.checked,
          isUpdated: !option.isUpdated
        }
      }
      return option
    })
    setOptList(updatedList)
  };

  const multipleUpdateCalls = async () => {
    const results = [];
    for (let i = 0; i < optList.length; i++) {
      if(optList[i].isUpdated){
        const payloadNumber = number[0] === "0" ? number.slice(1) : number
      try {
         let payload = {
          number: `966${payloadNumber}`,
          consent_type: optList[i].key === "AllowedInternalCall" ? "internal_call" : "external_call",
          status: optList[i].checked
        }
        const data = await Advertisement.updateAdvertisement(payload)
        results.push(data);
      } catch (error) {
        setLoading(false);
        break
      }
    }
    }
    return results;
  }

  const handleSubmit = () => {
    setLoading(true);
    multipleUpdateCalls().then((results)=>{
      const lastResult = results[results.length - 1];
      if(lastResult){
        Storage.set("act_step_detail", {
          step1: {
            status: "isDone",
          },
          step2: {
            status: "isDone",
          },
          step3: {
            status: "isDone",
          }
        })
        setShowSucessModal(true);
        setLoading(false);
      }
    })
  }

  const onContinue = () => {
    Storage.clear("act_number")
    history.push("/advertisement");
    setShowSucessModal(false);
  }

  const isOptionsChanged = useMemo(()=>{
   return optList.some((option)=> option.isUpdated)
  },[optList])


  return (
    <>
      {loading ? <SpinnerTimeLoader /> :
    <div className="stf-advertisement-list-container">
      <img src={advertisementImage} alt="advertisement" />
      <StorefrontTitle
        title={translationKeys[prefix + "title"]}
        desc={translationKeys[prefix + "desc"]}
      />
      {/* <div className="list-container"> */}
      {optList.map((option, index) => {
        return (
          <div className="list-container" key={index}>
            <div className="list-left">
              <img src={advertisementSpeaker} alt="speaker-all" />
              <div className="list-inner">
                <h4>{translationKeys[prefix + option?.key]}</h4>
                <p>
                  {translationKeys[prefix + "desc_" + option?.key]}
                </p>
              </div>
            </div>
            <div className="checkbox-container">
              <input
                value={option.key}
                id={"agree_id"}
                type="checkbox"
                name="validId"
                checked={option.checked}
                onChange={() => {
                  updateCheckbox(option.key);
                }}
              />
            </div>
          </div>
        )
      })}

      {/* </div> */}
      <div className="form-recaptcha">
        <ReCAPTCHA
          sitekey={Settings.get("google_recaptcha_site_key")}
          onChange={updateCaptcha}
        />
      </div> 
      <button
        className={"continue-button"}
        disabled={!captchaChecked || !isOptionsChanged}
        onClick={() => { handleSubmit() }}
      >
        {translationKeys[prefix + "save"]}
      </button>
      {showSucessModal ? <AdvertisementPopup onContinue={onContinue} history={history} /> : null}
        </div>}
    </>

  );
}
